import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { settingsAPI } from '../services/api'
import { EMAIL_SPAM_NOTE, SUPPORT_EMAIL } from '../config/support'
import UserMenu from './UserMenu'
import './Layout.css'

function Layout({ children }) {
  const { isAuthenticated } = useAuth()
  const [maintenanceMode, setMaintenanceMode] = useState(false)

  const fetchSettings = () => {
    settingsAPI.get()
      .then((data) => setMaintenanceMode(!!data?.maintenance_mode))
      .catch(() => setMaintenanceMode(false))
  }

  useEffect(() => {
    fetchSettings()
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') fetchSettings()
    }
    const onSettingsUpdated = () => fetchSettings()
    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('platform-settings-updated', onSettingsUpdated)
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      window.removeEventListener('platform-settings-updated', onSettingsUpdated)
    }
  }, [])

  return (
    <div className="app-layout">
      {maintenanceMode && (
        <div className="maintenance-banner" role="alert">
          The site is currently in maintenance mode. Some features may be temporarily broken.
        </div>
      )}
      <nav className="nav">
        <Link to={isAuthenticated ? "/dashboard" : "/"} className="nav-logo">
          <img src="/Alchemy-Logo-No-BG.png" alt="Alchemy Forum Logo" className="logo-img" onError={(e) => { e.target.style.display = 'none' }} />
          <div className="logo-text-group">
            <span className="logo-text">ALCHEMY</span>
            <span className="logo-accent">FORUM</span>
          </div>
        </Link>
        <div className="nav-links">
          <Link to={isAuthenticated ? "/dashboard" : "/"} className="nav-link">Home</Link>
          <Link to="/repositories" className="nav-link">Repositories</Link>
          {isAuthenticated && (
            <Link to="/founders" className="nav-link">Founders</Link>
          )}
          {!isAuthenticated && (
            <Link to="/about" className="nav-link">About</Link>
          )}
          <Link to="/docs" className="nav-link">Docs</Link>
          <Link to="/donate" className="nav-link nav-link-donate">Donate</Link>
          {isAuthenticated && <UserMenu />}
        </div>
      </nav>
      <main className="main-content">
        {children}
      </main>
      <footer className="footer">
        <p className="copyright">
          © 2025 Alchemy Forum. Share. Repair. Inspire.{' '}
          <span className="footer-links">
            <Link to="/docs" className="footer-link">
              Legal &amp; DMCA
            </Link>
            <span className="footer-link-sep" aria-hidden="true"> · </span>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="footer-link">
              {SUPPORT_EMAIL}
            </a>
          </span>
        </p>
        <p className="footer-spam-note">{EMAIL_SPAM_NOTE}</p>
      </footer>
    </div>
  )
}

export default Layout

